import React, {Component} from 'react';
import '../styles/Home.css'
import {Link} from "react-router-dom";
import Footer from "../shared/Footer";
import LoginService from "../admin/loginComponents/LoginService";
import {Button} from "react-bootstrap";
import {NotificationManager} from "react-notifications";

export default class Aktywacja extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reset: false,
            powodzenie: true,
            newPass: '',
            newPass2: ''
        };

        this.handleNewPass = this.handleNewPass.bind(this);
        this.handleNewPass2 = this.handleNewPass2.bind(this)
    }

    handleNewPass(e) {
        this.setState({newPass: e.target.value})
    }

    handleNewPass2(e) {
        this.setState({newPass2: e.target.value})
    }

    onUstawHaslo() {
        if (this.state.newPass === this.state.newPass2){
            if (this.state.newPass2.length >= 8){
                LoginService.ustawNoweHaslo(this.props.match.params.token, this.state.newPass2)
                    .then(function (response) {
                        if (response.status === 200) {
                            this.setState({reset: true, powodzenie: true, loading: false})
                        } else {
                            this.setState({reset: true, powodzenie: false, loading: false})
                        }
                    }.bind(this))
                    .catch(error => {
                        console.log(error)
                    })
            } else {
                NotificationManager.error("", "Hasło musi mieć minimum 8 znaków! ", 5000);
            }
        } else {
            NotificationManager.error("", "Podane hasła muszą być takie same! ", 5000);
        }

    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Załóż konto by uzyskać nowe możliwości!</b></h2>
                    <h4>Dzięki rejestracji uzyskasz dostęp do danych o swoich biletach, oraz informacje o kursach
                        eventowych.</h4>
                </div>
            </div>
            <div style={{background: '#efefef'}}>
                <div className="container" style={{padding: 15}}>
                    <div>
                        {this.state.reset ?
                            <div>{this.state.powodzenie ?
                                <div className="text-center ramka" style={{padding: 100, background: 'white'}}>
                                    <b><h2><i className="fa fa-2x fa-check" style={{color: '#53a53c'}}> </i> Reset hasła
                                        zakończony powodzeniem.</h2>
                                        <h5 style={{fontWeight: 400}}>Powrót do <Link
                                            to={'/login'}><b>logowania</b></Link></h5></b>
                                </div>
                                :
                                <div className="text-center ramka" style={{padding: 100, background: 'white'}}>
                                    <b><h2><i className="fa fa-2x fa-times" style={{color: '#c82825'}}> </i> Reset hasła
                                        nie
                                        powiódł się.</h2>
                                        <h5 style={{fontWeight: 400}}>Spróbuj ponownie lub skontaktuj się z BOK.</h5>
                                    </b>
                                </div>}
                            </div> :
                            <div className="text-center ramka" style={{padding: 100, background: 'white'}}>
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <h2><b>Reset hasła</b></h2>
                                        <p style={{
                                            fontSize: '0.875rem',
                                            paddingTop: '10px',
                                            marginBottom: '10px'
                                        }}>Podaj
                                            nowe hasło:</p>
                                        <div className="inputLogin"><i className="fa fa-lock"> </i>
                                            <input className="form-control inputLoginControl"
                                                   value={this.state.newPass}
                                                   onChange={this.handleNewPass}
                                                   placeholder="Podaj nowe hasło..."
                                                   type="password"/></div>
                                        <div className="inputLogin"><i className="fa fa-unlock-alt"> </i>
                                            <input className="form-control inputLoginControl"
                                                   value={this.state.newPass2}
                                                   onChange={this.handleNewPass2}
                                                   placeholder="Powtórz nowe hasło..."
                                                   type="password"/></div>
                                        <div className="buttonLogin" style={{marginTop: 10}}>
                                            <Button bsStyle="success" onClick={() => this.onUstawHaslo()}>
                                                Zmień hasło
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/ResetHasla.js